import {FetchBaseQueryError} from '@reduxjs/toolkit/query';

export const isFetchBaseQueryError = (
    err: unknown
): err is FetchBaseQueryError => {
    return !!err && typeof err === 'object' && 'status' in (err as any);
};
